export default [
    {
        name: 'warehouse.receive.create',
        path: '/warehouse/receive/goods-in',
        component: () => import("@/views/modules/warehouse/receive/GoodsIn.vue"),
    }
]
